import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: ['//at.alicdn.com/t/font_1916143_j9l04bdvw87.js', '//at.alicdn.com/t/c/font_3907322_8e8kt2uehuf.js'],
});

export default FontIcon;